export enum EntityType {
  SITE = 'site',
  SCHEDULE = 'schedule',
  FLOOR = 'floor',
  ZONE = 'zone',
  EQUIP = 'equip',
  POINT = 'point',
  DEVICE = 'device',
  KVTAG = 'kvtag'
}